import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89416dba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row mt-3 pb-3" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_10 = {
  class: "",
  height: "48",
  width: "48"
}
const _hoisted_11 = ["xlink:href"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = {
  key: 2,
  class: "mt-3"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "col-lg-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Timeline = _resolveComponent("Timeline")!
  const _component_Button = _resolveComponent("Button")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_Message = _resolveComponent("Message")!
  const _component_SupportCard = _resolveComponent("SupportCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.vm.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.vm.pageTitle)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.vm.pageTitle), 1))
                : _createCommentVNode("", true),
              _createElementVNode("p", {
                class: "lead",
                innerHTML: _ctx.vm.pageIntro
              }, null, 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.vm.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.vm.stepsTitle)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_8, _toDisplayString(_ctx.vm.stepsTitle), 1))
                : _createCommentVNode("", true),
              _hoisted_9,
              _createVNode(_component_Timeline, {
                class: "mb-3",
                value: _ctx.timeLineSteps
              }, {
                marker: _withCtx((slotProps) => [
                  (_openBlock(), _createElementBlock("svg", _hoisted_10, [
                    _createElementVNode("use", {
                      "xlink:href": slotProps.item.icon
                    }, null, 8, _hoisted_11)
                  ]))
                ]),
                content: _withCtx((slotProps) => [
                  _createElementVNode("h5", null, _toDisplayString(slotProps.item.title), 1),
                  _createElementVNode("p", {
                    innerHTML: slotProps.item.content
                  }, null, 8, _hoisted_12)
                ]),
                _: 1
              }, 8, ["value"]),
              (_ctx.vm.hasSoftware)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "mb-2 text-break",
                    innerHTML: _ctx.vm.softwareInstructions
                  }, null, 8, _hoisted_13))
                : _createCommentVNode("", true),
              (_ctx.vm.hasTrainings)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: "mb-2 text-break",
                    innerHTML: _ctx.vm.trainingInstructions
                  }, null, 8, _hoisted_14))
                : _createCommentVNode("", true),
              (_ctx.vm.hasExperts)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 3,
                    class: "mb-2 text-break",
                    innerHTML: _ctx.vm.expertInstructions
                  }, null, 8, _hoisted_15))
                : _createCommentVNode("", true),
              (_ctx.vm.hasSupport)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 4,
                    class: "mb-2 text-break",
                    innerHTML: _ctx.vm.supportInstructions
                  }, null, 8, _hoisted_16))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                class: "p-button-success p-button-lg p-button-raised mb-2",
                icon: "pi pi-arrow-right",
                "icon-pos": "right",
                label: _ctx.$t('checkout.button.goToMyCadac'),
                onClick: _cache[0] || (_cache[0] = ($event: any) => {
							_ctx.goToMyCadac();
							$event.target.disabled = true;
						})
              }, null, 8, ["label"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.$t("checkout.titleOrderFailed")), 1),
              _createVNode(_component_Message, {
                closable: false,
                severity: "error"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_i18n_t, { keypath: "checkout.message.orderFailed" }, {
                    default: _withCtx(() => [
                      (_ctx.vm.orderNumber)
                        ? (_openBlock(), _createElementBlock("b", _hoisted_18, "#" + _toDisplayString(_ctx.vm.orderNumber), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_SupportCard, {
          "support-page-url": _ctx.vm.supportPageUrl
        }, null, 8, ["support-page-url"])
      ])
    ])
  ]))
}